export { FeaturedPages, FeaturedPosts } from './FeaturedModule';
